import { Component, Input, OnInit } from '@angular/core';
import { Divida, OfertaNegociacao } from 'src/app/shared/models/customer-debt-renegociation';

@Component({
  selector: "app-informacoes-proposta",
  templateUrl: "./informacoes-proposta.component.html",
  styleUrls: ["./informacoes-proposta.component.scss"],
})
export class InformacoesPropostaComponent {
  @Input() debt: Divida;
  @Input() ofertaAtual: OfertaNegociacao;
}
